export interface AssignReview {
  id: string
  assignId: string
  category: number
  version: number
  value: number
}

export interface AssignReviewModel {
  value: number
}

export const ASSIGN_REVIEW_CATEGORY = {
  Unknown: 0, // 不明
  Equipment: 1, // 機材
  Planning: 2, // 段取り
  Environment: 3, // 環境
  Communication: 4, // コミュニケーション
  Condition: 5, // 体調
}

export const ASSIGN_REVIEW_VERSION = {
  Unknown: 0, // 不明
  V1: 1, // v1
  V2: 2, // v2
}
